import DownloadButton from "../components/tableButton/downloadButton";
import BuyNowButton from "../components/tableButton/buyNowButton";
import WaitingButton from "../components/tableButton/waitingButton";
import { encryptString, openInNewTab } from "./functions";
import TableDotDropdown from "../components/tableButton/tableDotDropdown";
import { width } from "@mui/system";
import ViewQuestionModal from "../components/ViewQuestionModal";
import ViewQuestionButton from "../components/tableButton/downloadButton";
import BundleElectiveData from "../pages/answers/bundleElectiveData";
import AnalyticsLink from "../pages/mockTest/analytics/AnalyticsLink";

const colorCodes = [
    { status: undefined, background: "#005ca8", foreground: "#fff", message: "Upload", },
    { status: "new", background: "#fddc00", foreground: "#000", message: "Upload Complete", },
    { status: "pending", background: "#fddc00", foreground: "#000", message: "Under Evaluation" },
    { status: "completed", background: "#54951f", foreground: "#fff", message: "Evaluated" },
    { status: "student_answer_rejected", background: "#800000", foreground: "#fff", message: "Rejected" }
]

const getStatusMessageAndColor = (answerState) => {
    const statusObj = colorCodes.find(item => item.status === answerState);
    return statusObj ? { message: statusObj.message, background: statusObj.background, foreground: statusObj.foreground } : { message: "Waiting For Paper Upload", background: "#fddc00", foreground: "#000" };
};

export const generateColumn = (portions) => {
    const isMentorShipStudent = JSON.parse(localStorage.getItem("prepca-login-data"))?.isMentorShipStudent;

    return portions
        ?.filter(m => isMentorShipStudent || m.name !== '100% (B)')
        .map(m => ({
            name: m.id,
            label: m.name
        }));
};

export const generateDataFromBundle = (data) => {
    let _subject = []
    // console.log(data)
    data?.forEach((d) => {
        d.Portions.forEach((p) => {
            d.Subjects.forEach((s) => {
                _subject.push({ groupId: d.groupId, portionId: p.id, subjectId: s.id })
            })
        })
    })
    // console.log(_subject)
    return _subject;
}


export const generateRowsEvaluated = (columns, subjects, navigate, section, state, subjectsInfo, getPracticeMcqResult) => {
    const isMockTestSection = section === "mockTest";
    let _all = [];

    subjects.forEach((s, i) => {
        let OrderedBundlePlanGroups = generateDataFromBundle(s.OrderedBundlePlanGroups);
        let _singleSubject = [...OrderedBundlePlanGroups, ...s.OrderedCustomPlanRecords];
        const isQuestions = s.QualityTests?.length > 0;
        let _single = {};

        _single.subject = (
            <>
                {s.name}
                {s.parentId != null && s.subjectType === 'elective' ? (
                    <b><br />({subjects.find((a) => a.id === s.parentId)?.name})</b>
                ) : null}
                {s.parentId == null && s.subjectType === 'elective' ? (
                    <>
                        <br />
                        <BundleElectiveData
                            subjectsInfo={subjectsInfo}
                            index={i}
                            subjectId={s.id}
                            state={state}
                        />
                    </>
                ) : null}
            </>
        );

        columns.forEach((c) => {
            if (c.name === "subject") return;

            let evaluatedData = s.Questions?.find((f) => f.portionId === c.name);
            let evaluated = evaluatedData?.StudentAnswers?.at(-1);
            const isMockTestAvailable = s?.AvailableTests?.find((f) => f.set === c.name);
            const onGoingMockTest = s?.QualityTests?.find((f) => f.set === c.name)?.details && !s?.QualityTests?.find((f) => f.set === c.name).details?.result;
            const resultData = s?.QualityTests?.find((f) => f.set === c.name)?.details?.result;

            const commonStyle = {
                display: "flex",
                justifyContent: "center",
                minWidth: "140px",
            };

            const waitingButton = (
                <div style={commonStyle}>
                    <button
                        style={{
                            backgroundColor: "#eee",
                            border: "solid 1px #e2e7ee",
                            padding: "8px 25px",
                            borderRadius: "5px",
                            fontSize: "11px",
                            color: "#000",
                            fontWeight: "600",
                        }}
                        disabled
                    >
                        Waiting
                    </button>
                </div>
            );

            // Non-Mock Test Section
            if (!isMockTestSection) {
                if (evaluated) {
                    _single[c.name] = (
                        <div style={commonStyle}>
                            {evaluated.answerState === 'completed' ? (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div
                                        className="marks"
                                        style={{
                                            border: "1px solid #e2e7ee",
                                            borderRight: "none",
                                            borderRadius: "5px 0 0 5px",
                                            padding: "4px 12px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {evaluated?.marks} / 100
                                    </div>
                                    <button
                                        style={{
                                            backgroundColor: "#6aba2a",
                                            border: "1px solid #e2e7ee",
                                            padding: "8px 25px",
                                            borderRadius: "0 5px 5px 0",
                                            fontSize: "11px",
                                            color: "#fff",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            const urlParams = new URLSearchParams(window.location.search);
                                            const studentId = urlParams.get("studentId");
                                            const token = urlParams.get("token");

                                            let url = `/dashboard/question/upload/evaluated/${c.name}/${encryptString(evaluated.questionId)}/${encryptString(state?.sessionId)}`;

                                            // Conditionally add query parameters
                                            const queryParams = [];
                                            if (studentId) queryParams.push(`studentId=${studentId}`);
                                            if (token) queryParams.push(`token=${token}`);

                                            if (queryParams.length > 0) {
                                                url += `?${queryParams.join("&")}`;
                                            }

                                            navigate(url);
                                        }}

                                    >
                                        View
                                    </button>
                                </div>
                            ) : (
                                waitingButton
                            )}
                        </div>
                    );
                } else {
                    _single[c.name] = waitingButton;
                }
            }

            // Mock Test Section
            else {
                if (isMockTestAvailable) {
                    if (resultData) {
                        _single[c.name] = (
                            <div style={commonStyle}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div
                                        className="marks"
                                        style={{
                                            border: "1px solid #e2e7ee",
                                            borderRight: "none",
                                            borderRadius: "5px 0 0 5px",
                                            padding: "4px 12px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {resultData?.marks} / {resultData?.fullMarks}
                                    </div>
                                    <button
                                        style={{
                                            backgroundColor: resultData?.qualified ? "#6aba2a" : "#e53935", // green if passed, red if failed
                                            border: "1px solid #e2e7ee",
                                            padding: "8px 25px",
                                            borderRadius: "0 5px 5px 0",
                                            fontSize: "11px",
                                            color: "#fff",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => { getPracticeMcqResult(isMockTestAvailable.subjectId, isMockTestAvailable.set) }}
                                        title={resultData?.qualified ? "View Passed Result" : "View Failed Result"}

                                    >
                                        {resultData?.qualified ? "Passed" : "Failed"}
                                    </button>

                                </div>
                            </div>
                        );
                    } else {
                        _single[c.name] = (
                            <div style={commonStyle}>
                                <button
                                    style={{
                                        backgroundColor: "blue",
                                        border: "1px solid blue",
                                        padding: "8px 25px",
                                        borderRadius: "5px",
                                        fontSize: "11px",
                                        color: "#fff",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        navigate(`/dashboard/practice-mcq-board/${isMockTestAvailable.subjectId}/${isMockTestAvailable.set}`)
                                    }
                                >
                                    {onGoingMockTest ? "In Progress" : "Test"}
                                </button>
                            </div>
                        );
                    }
                } else {
                    _single[c.name] = waitingButton;
                }
            }
            if (isMockTestSection) {
                _single[c.name] = (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                        {_single[c.name]}
                        <AnalyticsLink subjectId={s.id} set={c.name} subjectName={s.name}
                            status={resultData ? 'completed' : onGoingMockTest ? 'in-progress' : isMockTestAvailable ? 'not-started' : 'waiting'} />
                    </div>
                );
            }
        });

        _all.push(_single);
    });

    return _all;
};


export const generateRowsUploadAnswer = (columns, subjects, navigate, section, state, subjectsInfo) => {

    let _all = []
    //console.log(columns);
    subjects.forEach((s, i) => {
        // console.log(s);
        let OrderedBundlePlanGroups = generateDataFromBundle(s.OrderedBundlePlanGroups)
        let _singleSubject = [...OrderedBundlePlanGroups, ...s.OrderedCustomPlanRecords]
        // console.log(_singleSubject)
        // console.log(subjects);
        // console.log(subjects.find((a) => a.id == 38).name)

        let _single = {}
        _single.subject = <>{s.name}{s.parentId != null && s.subjectType == 'elective' ? <b><br />({subjects.find((a) => a.id == s.parentId)?.name})</b> : ""}{s.parentId == null && s.subjectType == 'elective' ? <><br /><BundleElectiveData subjectsInfo={subjectsInfo} index={i} subjectId={s.id} state={state} /></> : ""}</>;
        columns.forEach((c) => {
            if (c.name != "subject") {
                let index = _singleSubject.findIndex((f) => f.portionId === c.name)
                // console.log(s.Questions)
                let filterQuestion = s.Questions?.filter((f) => f.portionId === c.name)
                let findQuestion = filterQuestion[filterQuestion.length - 1]
                let data = findQuestion?.StudentAnswers[findQuestion?.StudentAnswers?.length - 1]
                // console.log(data);
                if (index >= 0) {
                    let checkQuestion = s.Questions.findIndex((f) => f.portionId === c.name)
                    // console.log(findQuestion, c.name, section)
                    //console.log(findQuestion)
                    if (checkQuestion >= 0) {
                        _single[c.name] = <div style={{ display: "flex", justifyContent: "center", minWidth: "200px" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                                {
                                    section == 'question' ?
                                        findQuestion?.question ?
                                            <div >
                                                {/* <button style={{
                                                    backgroundColor: getStatusMessageAndColor(data?.answerState).background,
                                                    border: "solid 1px #e2e7ee",
                                                    padding: "8px 25px",
                                                    borderRadius: "5px",
                                                    cursor: "pointer",
                                                    fontSize: "11px",
                                                    color: getStatusMessageAndColor(data?.answerState).foreground,
                                                    fontWeight: "600",
                                                    height: "40px",
                                                    width: "100px"
                                                }} onClick={() => navigate("/dashboard/question/upload/" + encryptString(findQuestion?.id) + "/" + encryptString(state?.sessionId) + "/" + c.name)}>{getStatusMessageAndColor(data?.answerState).message}</button> */}
                                                <WaitingButton iconColor={getStatusMessageAndColor(data?.answerState).background} onClick={() => navigate("/dashboard/question/upload/" + encryptString(findQuestion?.id) + "/" + encryptString(state?.sessionId) + "/" + c.name)} text={getStatusMessageAndColor(data?.answerState).message} />
                                            </div>
                                            : <WaitingButton text="Question pending" />
                                        :
                                        _single[c.name] = <div style={{ display: "flex", justifyContent: "center" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <WaitingButton text="Question pending" />
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    }
                    else {
                        _single[c.name] = <div style={{ display: "flex", justifyContent: "center", minWidth: "200px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <WaitingButton text="Question pending" />
                            </div>
                        </div>
                    }
                }
                else {
                    _single[c.name] = <div style={{ display: "flex", justifyContent: "center", minWidth: "200px" }}>
                        {s.subjectType != 'elective' || s.parentId ?
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                <div >
                                    <BuyNowButton text={"Buy Now"} onClick={() => navigate("/plans/customize/" + state.courseId + "/" + state.sessionId + "/" + state.syllabusId)} />
                                </div>
                            </div>
                            : ""
                        }
                    </div>
                }
            }
        })
        // console.log(_single);
        _all.push(_single)

    })
    // console.log(_all);
    return _all;

}
export const generateRows = (columns, subjects, navigate, section, state, subjectsInfo) => {

    let _all = []
    //console.log(columns);
    subjects.forEach((s, i) => {
        // console.log(s);
        let OrderedBundlePlanGroups = generateDataFromBundle(s.OrderedBundlePlanGroups)
        let _singleSubject = [...OrderedBundlePlanGroups, ...s.OrderedCustomPlanRecords]
        // console.log(_singleSubject)
        // console.log(subjects);
        // console.log(subjects.find((a) => a.id == 38).name)

        let _single = {}
        _single.subject = <>{s.name}{s.parentId != null && s.subjectType == 'elective' ? <b><br />({subjects.find((a) => a.id == s.parentId)?.name})</b> : ""}{s.parentId == null && s.subjectType == 'elective' ? <><br /><BundleElectiveData subjectsInfo={subjectsInfo} index={i} subjectId={s.id} state={state} /></> : ""}</>;
        columns.forEach((c) => {
            if (c.name != "subject") {
                let index = _singleSubject.findIndex((f) => f.portionId === c.name)
                let filterQuestion = s.Questions?.filter((f) => f.portionId === c.name)
                let findQuestion = filterQuestion[filterQuestion.length - 1]
                let studentAnswer = findQuestion?.StudentAnswers?.[0]?.answer
                if (index >= 0) {
                    let checkQuestion = s.Questions.findIndex((f) => f.portionId === c.name)
                    if (checkQuestion >= 0) {
                        _single[c.name] = <div style={{ display: "flex", justifyContent: "center", minWidth: "200px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                                {
                                    section === 'question' ? (
                                        findQuestion?.question ? (
                                            <>
                                                <div>
                                                    <ViewQuestionButton from="question" questionId={findQuestion?.id} pdf={findQuestion?.question} />
                                                </div>
                                                {/* <TableDotDropdown state={state} questionId={findQuestion?.id} /> */}
                                            </>
                                        ) : (
                                            <WaitingButton text="Waiting for Paper" />
                                        )
                                    ) : section === 'answer' ? (
                                        findQuestion?.answer ? (
                                            <div>
                                                <ViewQuestionButton from="answer" questionId={findQuestion?.id} pdf={findQuestion?.answer} />
                                            </div>
                                        ) : !studentAnswer ? (
                                            <WaitingButton text="Upload Answer Sheet" />
                                        ) : (
                                            <WaitingButton text="Waiting for Evaluation" />
                                        )
                                    ) : null
                                }

                            </div>
                        </div>
                    }
                    else {
                        _single[c.name] = <div style={{ display: "flex", justifyContent: "center", minWidth: "200px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <WaitingButton text="Waiting for Paper" />
                                {
                                    // section == 'question' ?
                                    //     <TableDotDropdown state={state} questionId={findQuestion?.id} /> : null
                                }

                            </div>
                        </div>
                    }
                }
                else {
                    _single[c.name] = <div style={{ display: "flex", justifyContent: "center", minWidth: "200px" }}>
                        {s.subjectType != 'elective' || s.parentId ?
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div >
                                    <BuyNowButton text={"Buy Now"} onClick={() => navigate("/plans/customize/" + state.courseId + "/" + state.sessionId + "/" + state.syllabusId)} />
                                </div>
                                {
                                    // section == 'question' ?
                                    //     <TableDotDropdown state={state} questionId={findQuestion?.id} /> : null
                                }
                            </div>
                            : ""
                        }
                    </div>
                }
            }
        })
        // console.log(_single);
        _all.push(_single)

    })
    // console.log(_all);
    return _all;

}

export const generateForMobile = (columns, rows) => {
    let data = []
    rows.map((r) => {
        let single = {
            name: r.subject,
            links: [],
            open: false,
        }
        let links = []
        columns.map((c) => {
            links.push({ title: c.label, button: r[c.name], to: "#" },)
        })
        single.links = [...links]
        data.push(single)
    })
    return data;
}
